<template>
  <div id="app">
    <!-- <headerComp/> -->
    <headerComp v-if="authState"/>
    <authComp v-else/>
  </div>
</template>

<script>

import headerComp from './components/header.vue';
import authComp from './components/auth.vue';
import { mapState } from 'vuex' //this is so we can listen for some changes to the auth state.

export default {
  name: 'App',
  components: {
    headerComp,
    authComp
  },
  mounted(){
    
  },
  computed: 
    mapState([
            'authState',
        ])
}
</script>
